import io from 'static/script/libs/socket.io';
import Logger from 'static/script/utils/logger';

function BidNotifierData () {

    this._socket = {};

    this.defaultAttrs({
        buyingEventPusherServerUrl: null,
        itemId: null,
        featureSwitches: null,
        buyingEventPusherEnabled: null
    });


    this._listenToBuyingEvents = function () {
        let ioLocation = this.attr.buyingEventPusherServerUrl;

        if (!ioLocation) {
            return;
        }

        try {
            this._socket = io.connect(ioLocation);
        } catch (e) {
            this.logInfo(e, 'Socket IO failed to connect.');
            return;
        }

        if (!Array.isArray(this.attr.itemId)) {
            this.attr.itemId = [this.attr.itemId];
        }

        this._socket.on('connect', function () {
            try {
                for (let i in this.attr.itemId) {
                    if (this.attr.itemId[i]) {
                        let itemId = this.attr.itemId[i];
                        this._socket.emit('joinChannel', itemId);
                    }
                }
            } catch (e) {
                this.logInfo(e, 'Socket IO failed to join channel.');
                return;
            }
        }.bind(this));


        this._socket.on('clientEvent', function (payload) {
            try {
                this._handleClientEvent(payload);
            } catch (e) {
                this.logInfo(e, 'Socket IO failed to handle client event.');
                return;
            }
        }.bind(this));
    };

    this._disconnectSocket = function () {
        if (this._socket && this._socket.socket) {
            try {
                this._socket.socket.disconnect();
            } catch (e) {
                this.logInfo(e, 'Socket IO failed to disconnect.');
                return;
            }
        }
    };

    this._handleClientEvent = function (data) {
        if (data.Type) {
            switch (data.Type) {
                case 'AuctionLeadingBidUpdated':
                case 'IAuctionLeadingBidUpdated':
                    this.trigger(document, 'data:notifications:on-bid-update', data.Event);
                    break;
            }
        } else {
            this.trigger(document, 'data:notifications:on-bid-update', data);
        }
    };

    this._shouldEnableLiveUpdates = function () {
        if (!this.attr.featureSwitches) {
            return false;
        }
        if (!this.attr.buyingEventPusherEnabled) {
            return false;
        }
        if (typeof this.attr.featureSwitches.vipliveupdates !== 'undefined' && !this.attr.featureSwitches.vipliveupdates) {
            return false;
        }
        if (typeof this.attr.featureSwitches.rpliveupdates !== 'undefined' && !this.attr.featureSwitches.rpliveupdates) {
            return false;
        }
        return true;
    };

    this.after('initialize', function () {

        if (this._shouldEnableLiveUpdates()) {
            if (document.readyState && (document.readyState === 'complete' || document.readyState.state === 'complete')) {
                this._listenToBuyingEvents();
            } else {
                $(window).on('load', this._listenToBuyingEvents.bind(this));
            }

            this.on(document, 'ui:teardown', this._disconnectSocket);
        }
    });
}

export default Logger.mixin(BidNotifierData);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/data/bid-notifier.js